// Two ways to tuck secondary detail away in the Business Portal, built on <details> so they work with the keyboard
// and without script.
//   DisclosureLink — a quiet text link: chevron, then the label, together on the left.
//   DisclosureRow  — a full-width row in a list: label on the left, chevron on the right.
import { ChevronDown } from "lucide-react";
import { focusRing } from "./cn";

const summaryBase = `cursor-pointer list-none rounded-control ${focusRing} [&::-webkit-details-marker]:hidden`;
const chevron = "h-4 w-4 shrink-0 text-tertiary transition-transform group-open:rotate-180";

export function DisclosureLink({ label, children, className = "", contentClassName = "" }) {
  return (
    <details className={`group text-sm ${className}`}>
      <summary className={`${summaryBase} inline-flex min-h-10 items-center max-md:min-h-touch gap-1.5 font-medium text-secondary hover:text-foreground`}>
        <ChevronDown className={chevron} aria-hidden="true" />
        <span>{label}</span>
      </summary>
      <div className={contentClassName}>{children}</div>
    </details>
  );
}

export function DisclosureRow({ label, hint, children, className = "", contentClassName = "" }) {
  return (
    <details className={`group ${className}`}>
      <summary className={`${summaryBase} flex min-h-11 items-center justify-between gap-3 py-2`}>
        <span className="min-w-0">
          <span className="block text-body-sm font-medium text-foreground">{label}</span>
          {hint ? <span className="block text-meta text-secondary">{hint}</span> : null}
        </span>
        <ChevronDown className={chevron} aria-hidden="true" />
      </summary>
      <div className={contentClassName}>{children}</div>
    </details>
  );
}
